<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3" ref="searchDiv">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 入库编號" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<!-- <el-button class="mr-2"  @click="openModel(false,1)" type="primary" size="mini" 
					v-auth="'add'+auth_val">入库</el-button> -->
					<!-- <el-button type="warning" v-auth="'add'+auth_val" @click="openModel(2)" size="mini">出库</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="入库编號" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索入库编號"></el-input>
						</el-form-item>
						
						
						<el-form-item label="商戶">
							<el-select v-model="from.shop_id" multiple  clearable size="small" filterable placeholder="請選擇" style="width: 85%;">
								<!-- <el-option  label="全部" :value="-1"> -->
								</el-option>
								<el-option v-for="item in shop_list" :key="item.id" :label="item.name+'（'+item.username+')'" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						
						
						<el-form-item label="交货方式" class="mb-0">
							<el-select v-model="from.order_type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="自寄海外仓" :value="1"></el-option>
								<el-option label="自寄中转仓" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						
						
					
						
						<el-form-item label="狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="待確認" :value="0"></el-option>
								<el-option label="待发货" :value="1"></el-option>
							</el-select>
						</el-form-item>
						
					


						<el-form-item label="時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange" @expand-change="checkLog" :max-height="tableHeight">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<el-table-column type="expand" label="明细" width="80">
				  <template slot-scope="v">
					  
					  <el-tabs v-model="v.row.ac_type" type="border-card" >
						  <el-tab-pane label="基础信息" name="info">
							  <el-row>
								  <el-col :span="12">
									  <div class="tt_div">
										  <div class="tt_w">
											  <el-tag type="info">运輸方式：</el-tag>
										  </div>
										  <div>
											  <span v-if="v.row.transport_type==1">快递</span>
											  <span v-if="v.row.transport_type==2">空运</span>
											  <span v-if="v.row.transport_type==3">海运</span>
											  <span v-if="v.row.transport_type==4">其他</span>
										  </div>
									  </div>
									 
								  </el-col>
								  <el-col :span="12">
									  <div class="tt_div">
										  <div class="tt_w">
											  <el-tag type="info">報关方式：</el-tag>
										  </div>
										  <div>
											  <span v-if="v.row.declare_type==1">單独退税報关</span>
											  <span v-if="v.row.declare_type==2">不退税報关</span>
										  </div>
									  </div>
								  </el-col>
								  
								  <el-col :span="12">
									  <div class="tt_div">
										  <div class="tt_w">
										  	<el-tag type="info">柜型：</el-tag>
										  </div>
										  <div>
											  <span v-if="v.row.container_type==1">45HQ</span>
											  <span v-if="v.row.container_type==2">40GP</span>
											  <span v-if="v.row.container_type==3">40HQ</span>
											  <span v-if="v.row.container_type==4">20GP</span>
										  </div>
									  </div>
								  									 
								  </el-col>
								  <el-col :span="12">
									  <div class="tt_div">
										  <div class="tt_w">
										  	<el-tag type="info">预计到货：</el-tag>
										  </div>
										  <div>
												<span>{{v.row.expect_time}}</span>
										  </div>
									  </div>
								  </el-col>
								  
								 <!-- 
								  <el-col :span="12">
									  <div class="tt_div">
										  <div class="tt_w">
											<el-tag type="info">转單號：</el-tag>
										  </div>
										  <div>
											  <span>{{v.row.transfer_number}}</span>
										  </div>
									  </div>
								  									 
								  </el-col> -->
								  <el-col :span="12">
									  <div class="tt_div">
										  <div class="tt_w">
											<el-tag type="info">確認時間：</el-tag>
										  </div>
										  <div>
												<span>{{v.row.success_time}}</span>
										  </div>
									  </div>
								  </el-col>
							  <el-col :span="12" v-if="v.row.order_type==2">
									  <div class="tt_div">
										  <div class="tt_w">
											<el-tag type="info">中转仓：</el-tag>
										  </div>
										  <div>
												<span>{{v.row.go_name_s}}</span>
										  </div>
									  </div>
								  </el-col>
								  
								  
								  
								  <el-col :span="12" >
								  <div class="tt_div">
									  <div class="tt_w">
										<el-tag type="info">收货信息：</el-tag>
									  </div>
									  <div>
										<div v-if="v.row.order_type==1">
											<div>
												<span>{{v.row.addres}}</span>
												<span class="ml-3">{{v.row.go_phone}}</span>
											</div>
											<div class="mt-2">
												{{v.row.go_local}}
											</div>
										</div>
										<div v-if="v.row.order_type==2">
											<div>
												<span>{{v.row.s_addres}}</span>
												<span class="ml-3">{{v.row.s_phone}}</span>
											</div>
											<div class="mt-2">
												{{v.row.s_locla}}
											</div>
										</div>
									  </div>
								  </div>
								  </el-col>
								  
							  </el-row>
						  </el-tab-pane>
					      <el-tab-pane label="商品信息" name="log">
							  <el-table
								:data="v.row.log"
								border
								max-height="350"
								style="width: 100%;">

								<el-table-column align="center" prop="name"  label="商品名稱"></el-table-column>
								<el-table-column align="center" prop="sku"  label="SKU"></el-table-column>
								<el-table-column align="center" prop="box"  label="箱號"></el-table-column>
								
								<el-table-column width="200" align="center" prop="order_no"  label="外箱条形碼"></el-table-column>
								<!-- <el-table-column align="center" width="180" prop="head"  label="外箱条形碼">
									<template slot-scope="k">
										<el-image style="width: 140px; height: 40px" :src="k.row.no_img" :preview-src-list="[k.row.no_img]"></el-image>
									</template>
								</el-table-column> -->
								
								<el-table-column align="center" prop="num"  label="單箱數量"></el-table-column>
								<el-table-column align="center" prop="weight"  label="重量"></el-table-column>
								
								<el-table-column align="center"  prop="num"  label="狀態">
									<template slot-scope="k">
										<span v-if="k.row.status==0" style="color: #999;">待確認</span>
										<span v-if="k.row.status==1" class="text-success">海外仓已入库</span>
										<span v-if="k.row.status==2" class="text-warning">中转已入库</span>
										<span v-if="k.row.status==3" class="text-warning">待入库</span>
									
										
									</template>
								</el-table-column>
								<el-table-column align="center" prop="ok_time" width="200" label="入库時間"></el-table-column>
								
								
								<el-table-column v-if="v.row.order_type==2" align="center" width="180" prop="head"  label="中转仓入库拍摄">
									<template slot-scope="k">
										<el-image v-if="k.row.start_img" style="width: 140px; height: 40px" :src="k.row.start_img" :preview-src-list="[k.row.start_img]"></el-image>
									</template>
								</el-table-column>
								
								<el-table-column  align="center" width="180" prop="head"  label="海外仓入库拍摄">
									<template slot-scope="k">
										<el-image v-if="k.row.end_img" style="width: 140px; height: 40px" :src="k.row.end_img" :preview-src-list="[k.row.end_img]"></el-image>
										
									</template>
								</el-table-column>
								
								
							
							  </el-table>
							  
						  </el-tab-pane>
					      
					      <el-tab-pane label="操作日志" name="msg">
							  <el-table
									:data="v.row.msg_arr"
									border
									 max-height="350"
									style="width: 100%;">
									
									
									
									<el-table-column align="center" prop="admin_name"  label="操作者"></el-table-column>
									<el-table-column align="center" prop="type_name"  label="操作詳情"></el-table-column>
									
									
									<el-table-column align="center" prop="create_time"  label="時間"></el-table-column>
									
									
									
								
								  </el-table>
							  
						  </el-tab-pane>
					    </el-tabs>
					 </template>
				</el-table-column>
							
							
				
				
				<!-- <el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column> -->
			
				
			
		
				
				<el-table-column align="center" width="180" prop="order_no" label="入库编號">
				</el-table-column>
				
			
				
			<el-table-column align="center" prop="sp_name" width="150" label="对应商戶">
				<template slot-scope="v">
					<span>{{v.row.shop_name}}(<span class="text-danger">{{v.row.username}}</span>)</span>
					
					
				</template>
			</el-table-column>
				
				
				<el-table-column align="center" prop="total_box"  label="總箱數">
			
				</el-table-column>
				<el-table-column align="center" prop="total_ru"  label="已入箱數"></el-table-column>
				<el-table-column align="center" prop="total_wei"  label="重量"></el-table-column>
				
				<el-table-column align="center"  prop="num"  label="交货方式">
					<template slot-scope="v">
						<span v-if="v.row.order_type==1" >自寄海外仓</span>
						<span v-if="v.row.order_type==2" >自寄中转仓</span>
						
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="go_name" width="140"  label="目的仓库"></el-table-column>
				<el-table-column align="center" prop="remark"  label="備註"></el-table-column>
				
				
				<el-table-column align="center"  prop="num"  label="狀態">
					<template slot-scope="v">
						<span v-if="v.row.status==0" style="color: #999;">待確認</span>
						<span v-if="v.row.status==1" class="text-success">审核通过</span>
						<span v-if="v.row.status==2" class="text-danger">拒绝</span>
						
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="status_remark"  label="审核備註"></el-table-column>
				
				
	
			
		
				<!-- 
				<el-table-column align="center" sortable="custom" prop="status"  label="狀態">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			 -->
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="下單時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<el-button v-if="scope.row.status==0" v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,1)">通过</el-button>
							
							<el-button v-if="scope.row.status==0" @click="openModel(scope.row,2)"  v-auth="'edit'+auth_val" size="mini" plain type="danger">拒绝</el-button>
							
							
						<!-- 	<el-button v-if="scope.row.status==1"  v-auth="'print'+auth_val" size="mini" plain type="info" @click="openPrintModel(scope.row)">打印</el-button> -->
							
						

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



	<el-dialog  :close-on-click-modal="false" :title="form.status==1?'通过':'拒绝'" :visible.sync="createModel"
	top="5vh" :width="layout.is_phone?'90%':'50%'">
		<!-- 表單内容 -->
		<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
			
			
			
			<el-form-item label="入库编號" prop="name">
				{{form.order_no}}
			</el-form-item>
			
			<el-form-item label="交货方式" prop="sku">
				{{form.order_type==1?'自寄海外仓':'自寄中转仓'}}
			</el-form-item>
	
			
			
			<el-form-item label="审核備註" prop="status_remark">
				<el-input type="textarea" :rows="6" v-model="form.status_remark" 
				placeholder="請輸入审核備註" 
				clearable size="small" style="width: 85%;"></el-input>
			</el-form-item>
		
	
			
			
		</el-form>
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="createModel = false">取 消</el-button>
			<el-button type="primary" @click="submit">確 定</el-button>
		</div>
	</el-dialog>
	
	
		
		<el-dialog  :close-on-click-modal="false" title="打印条碼" :visible.sync="printModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rulesprint" ref="formEdit" :model="printData" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				
				<el-form-item label="打印類型" prop="size">
					<el-radio-group   v-model="printData.type" size="small">
						<el-radio :label="2" border>外箱条形碼</el-radio>
						<el-radio :label="3" border>产品条形碼</el-radio>
						
					</el-radio-group>
				</el-form-item>
				
				
				<el-form-item label="打印尺寸" prop="size">
					<el-radio-group   v-model="printData.size" size="small">
						<el-radio :label="1" border>100*100</el-radio>
						<el-radio :label="2" border>100*150</el-radio>

					</el-radio-group>
				</el-form-item>
				
				
				
			
				
	
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="printModel = false">取 消</el-button>
				<el-button type="primary" @click="submitPrint">確 定</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {

					status_remark: [{
							required: true,
							message: "請輸入审核備註",
							trigger: 'blur',
						},
					],
					
					
					
				},
				rulesprint:{
					
				},
				printModel: false,
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					shop_id:'',
					status:-1,
					order_type:-1,
					time: [],
				},
				model_title: 'First',
				auth_val: 'First',
				preUrl: "user/firstList", //列表地址
				addUrl: "user/addFirst", //添加/修改地址
				editStatusUrl: "user/editStatusFirst", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					status:0,
					status_remark:''
					
				},
				printData:{
					id:0,
					size:1,
					is_pro:1
				},
				logItem:{
					pid:'',
					box:1,
					num:'',
				},
				prop: 'create_time',
				sort: 'descending',
				slist: [],
				plist: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				now_num:0,
				godown_1:[],
				godown_2:[],
				product:[],
				shop_list:[],
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('shopList');
		},
		methods: {
			openPrintModel(e){
				this.printData = {
					id:e.id,
					size:1,
					type:2
				}
				this.printModel = true
				
			},
			submitPrint(){
				// window.open('/admin/user/printCode?id=1','_blank')
				this.axios.post('/admin/user/printCode',
					this.printData
				, {
					token: true,
				}).then(res => {
					let all = res.data
					
					if(all.code==1){
						this.printModel = false
						 window.open('/admin/user/printBar?fp='+all.data.list.token,'_blank')
					}else{
						this.$message({
							message: '打印调用失敗',
							type: 'error'
						});
					}
					
				}).catch(err => {
					// 失敗
				})
			},
			checkLog(row,expandedRows){
				if(row.is_check_msg==0){
					this.checkLogApi(row)
					
				}
			},
			
			checkLogApi(row){
					this.axios.post('/admin/user/checkFirstMsg',
						{id:row.id}
					, {
						token: true,
					}).then(res => {
						let all = res.data
						if(all.code==1){
							row.is_check_msg = 1
							row.msg_arr = all.data.list
							console.log(row.msg_arr)
						}
						
						
			
						
					}).catch(err => {
						// 失敗
						
					})
				
			},
			
			
			checkPnum(){
				if(this.form.sid && this.form.pid){
					//console.log("查询")
					this.checkPnumApi()
				}
			},
			checkPnumApi(){
					this.axios.post('/admin/data/CheckPnum',
						this.form
					, {
						token: true,
					}).then(res => {
						let all = res.data
						
						this.now_num = all.data.now_num

						
					}).catch(err => {
						// 失敗
						
					})
				
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
				
					
					this.shop_list = list
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						
					// 	if(!this.form.head){
					// 		this.$message.error('請傳入店铺图片');
					// 		return false
					// 	}
					
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			  
		
			
			addLog(){
				let logdata = this.deepClone(this.logItem)
				logdata.box = this.form.log.length + 1
				this.form.log.push(logdata)
			},
			
			
			delLog(index){
				if(index!=0){
					this.form.log.splice(index, 1);
					for(let i = 0;i<this.form.log.length;i++){
						this.form.log[i].box = i + 1 
					}
				}
			},

			// 打开模态框
			openModel(e, type) {
				
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						order_type:e.order_type,
						order_no:e.order_no,
						status: type,
						status_remark: '',
					}
					this.editIndex = e.id
				}else{
					let log_arr = []
					log_arr[0] = this.deepClone(this.logItem);
					this.form = {
						id: 0,
						order_type:1,
						start_id:'',
						end_id:'',
						expect_time:'',
						transfer_number:'',
						transport_type:1,
						declare_type:1,
						container_type:'',
						remark:'',
						log:log_arr,
					}
					this.editIndex = -1
				}
				
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					shop_id:'',
					status:-1,
					order_type:-1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
	.protable{
		width: 94%;
		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
		    -webkit-appearance: none;
		}
		input[type="number"] {
		    -moz-appearance: textfield;
		}
		inpit {
		    border: none
		}
	}
	.protable th,.protable td{
		text-align: center;
		line-height: 40px;
	}
	.tt_w{
		width: 100px;
	}
	.tt_div{
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		
		
	}
</style>
